<template>
  <div class="display">
    <h1 :style="{'font-family': font}">{{ chassi }}</h1>
  </div>
</template>

<script>
export default {
  name: 'PrintTermica',
  data: () => ({
    font: '',
    label: '',
    chassi: ''
  }),
  methods: {
    readFont () {
      if (this.$route.params.chassi) {
        this.font = this.$route.params.font
        this.label = this.$route.params.label
        this.chassi = this.$route.params.chassi
        setTimeout(() => {
          print()
          this.updateLastPrintDate()
          this.$router.push({ name: 'home', params: { font: this.font, label: this.label, chassi: this.chassi } })
        })
      }
    },
    async updateLastPrintDate () {
      if (window.uid) {
        try {
          const timestamp = Date.now()
          await this.$firebase.database()
            .ref(`users/${window.uid}/lastPrintDate`)
            .set(timestamp)
        } catch (error) {
          console.error('Erro ao salvar data da impressão:', error)
          // Não quebra o fluxo em caso de erro
        }
      }
    }
  },
  mounted () {
    this.readFont()

    // Fecha o aviso da LGPD
    const warning = document.querySelector('.warning')
    warning.classList.add('warning-close')
  },

  beforeDestroy () {
    // Abre novamente se o usuário não tiver aceito o aviso da LGPD
    const cookie = document.cookie.match(new RegExp('(^| )Cookie=([^;]+)'))
    if (!cookie) {
      const warning = document.querySelector('.warning')
      warning.classList.remove('warning-close')
    }
  }
}
</script>

<style lang="scss" scoped>
.display {
  position: fixed;
  top: 0;
  left: 0;
  background-color: #ffffff;
  height: 100%;
  width: 100%;
  h1 {
    font-size: 42px;
    padding-top: 70px;
    padding-right: 135px; /*Alterado*/
    letter-spacing: 10px;
    transform: scale(-1, 1);
    text-align: right; /*Alterado*/
  }
}
</style>
